import { type CategoryTypeaheadCategoryFragment } from '../components/typeahead/__generated-gql-types__/CategoryTypeahead.generated';

import { BOOTCAMPS_RELATIVE_URL } from './constants';
import { getCategorySRPUrl } from './hooks/useChangeCategory';

export const getBootcampSRPUrl = (
  category: Possible<CategoryTypeaheadCategoryFragment>,
) => {
  return getCategorySRPUrl(category, BOOTCAMPS_RELATIVE_URL);
};

export const getBootcampUrl = (bootcampSlug: string) => {
  return `/bootcamps/${bootcampSlug}`;
};
